<template>
  <div>
    <v-container fluid>
      <v-card class="card-detail-dataintegration mt-3" elevation="0">
        <v-row no-gutters class="mb-4">
          <v-col cols="12">
            <v-sheet class="integration-name-sheet" elevation="1" border rounded>
            <v-row class="align-center" no-gutters>
              <v-col cols="auto">
                <v-img :src="images.tableImg" width="24" height="24" class="mr-4" />
              </v-col>
              <v-col>
                <div class="integration-name-value-simple">
                  {{ DataIntegrationName || "-" }}
                </div>
              </v-col>
            </v-row>
          </v-sheet>
          </v-col>
        </v-row>
        <v-expansion-panels
          multiple
          accordion
          flat
          dense
          v-model="panel"
          class="expand-panel modern-panels"
        >
          <v-expansion-panel>
            <v-expansion-panel-title
            class="custom-expansion-title"
              id="detail-Configuration-dataintegration"
            >
              <template v-slot:actions="{ expanded }">
                <v-icon
                  :style="{
                    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  }"
                  class="expansion-icon"
                  size="35"
                >
                  mdi-menu-down
                </v-icon>
              </template>
              <div class="expansion-title-content">
                <span class="expansion-header">{{ $t('schema') }}</span>
              </div>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <div class="configuration-container">
                <!-- Configuration Cards -->
                <div
                  v-for="(item, index) in DataCol"
                  :key="index"
                  class="config-card-wrapper"
                >
                  <v-card class="config-card" elevation="1" rounded="lg">
                    <v-card-text class="config-card-content">
                      <div class="config-header">
                        <v-icon color="red-darken-4" size="20" class="mr-2"
                          >mdi-view-column</v-icon
                        >
                        <span class="config-title"
                          >{{ $t('column') }} {{ index + 1 }}</span
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="type == 'E'"
                          :id="
                            'detail-E-button-DeleteAction-dataintegration-' +
                            index
                          "
                          variant="text"
                          size="small"
                          color="error"
                          icon
                          @click="DeleteAction(index)"
                          class="config-delete-btn"
                        >
                          <v-icon size="18">mdi-delete</v-icon>
                        </v-btn>
                      </div>

                      <v-row class="config-fields" no-gutters>
                        <!-- Column Name Field -->
                        <v-col
                          cols="12"
                          :md="type == 'I' ? 6 : 12"
                          class="field-col"
                          :class="{ 'pr-3': type == 'I' }"
                        >
                          <div class="field-group">
                            <label
                              :for="'detail-configuration-column-dataintegration-' + index"
                              class="field-label"
                            >
                              {{ $t('columnName') }}
                              <span class="required">*</span>
                            </label>
                          </div>
                          <v-text-field
                            :id="
                              'detail-configuration-column-dataintegration-' +
                              index
                            "
                            :placeholder="$t('_columnDataIntegration')"
                            v-model="item.newCol"
                            variant="outlined"
                            density="compact"
                            class="config-field modern-input"
                            :error="errorMessages.columns[index]?.error"
                            :error-messages="errorMessages.columns[index]?.message"
                            hide-details="auto"
                          />
                        </v-col>
                        <!-- Data Type Field -->
                        <v-col
                          cols="12"
                          md="6"
                          v-if="type == 'I'"
                          class="field-col pl-3"
                        >
                          <div class="field-group">
                            <label
                              :for="'detail-I-configuration-datatype-dataintegration-' + index"
                              class="field-label"
                            >
                              {{ $t('dataType') }}
                              <span class="required">*</span>
                            </label>
                          </div>
                          <v-autocomplete
                            :id="
                              'detail-I-configuration-datatype-dataintegration-' +
                              index
                            "
                            :placeholder="$t('_typeDataIntegration')"
                            :items="DDDataType"
                            item-title="name"
                            item-value="id"
                            clearable
                            density="compact"
                            variant="outlined"
                            v-model="item.typeId"
                            @update:model-value="setDefault(item)"
                            hide-details
                            class="config-field modern-input"
                          />
                        </v-col>
                      </v-row>

                      <div class="fuzzy-personal-container">
                        <v-row no-gutters>
                          <v-col cols="12" sm="6" style="display: flex;">
                            <!-- Fuzzy Dropdown -->
                            <div class="fuzzy-dropdown-wrapper">
                              <div class="field-group">
                                <label
                                  :for="'detail-editdatatype-float-dataintegration-' + id"
                                  class="field-label"
                                >
                                  {{ $t('fuzzyMatching') }}
                                  <span class="required">*</span>
                                </label>
                              </div>
                              <v-select
                                :items="fuzzyOptions"
                                item-title="text"
                                item-value="value"
                                :model-value="getFuzzyValue(item)"
                                @update:model-value="
                                  setFuzzyValue(item, $event)
                                "
                                :disabled="item.typeId != 'nvarchar' && item.typeId != 'varchar' && item.typeId != 'varchar2' && item.typeId != 'text' 
                                  && item.typeId != 'char' && item.typeId != 'nchar' && item.typeId != 'VARCHAR2' && item.typeId != 'TEXT'
                                  && item.typeId != 'CHAR' && item.typeId != 'NCHAR' && item.typeId != 'NVARCHAR2'"
                                variant="outlined"
                                density="compact"
                                hide-details
                                class="fuzzy-select modern-input"
                                color="#C32E0E"
                              >
                                <template
                                  v-slot:selection="{ item: selectedItem }"
                                >
                                  <div class="selection-content">
                                    <span class="selection-text">{{
                                      selectedItem.raw.text
                                    }}</span>
                                  </div>
                                </template>

                                <template
                                  v-slot:item="{ props, item: dropdownItem }"
                                >
                                  <v-list-item
                                    v-bind="props"
                                    class="fuzzy-list-item"
                                  >
                                    <v-list-item-subtitle
                                      class="fuzzy-item-subtitle"
                                    >
                                      {{ dropdownItem.raw.description }}
                                    </v-list-item-subtitle>
                                  </v-list-item>
                                </template>
                              </v-select>
                            </div>
                            <div
                              v-if="type == 'E' && (item.typeId == '' || item.typeId == null)"
                              @click.stop="validateColumnNameAndType(index)"
                              class="validate-button"
                              :class="{ 'validate-button--loading': validatingColumnIndex === index }"
                              :aria-disabled="validatingColumnIndex === index"
                            >
                              <v-progress-circular v-if="validatingColumnIndex === index" indeterminate size="18" width="2" class="mr-2" />
                              <v-icon v-else class="mr-2">mdi-refresh-circle</v-icon>
                              {{ validatingColumnIndex === index ? $t('validating') : $t('validateColumn') }}
                            </div>
                          </v-col>

                          <!-- Personal Information Switch -->
                          <v-col cols="12" sm="6">
                            <div class="personal-info-wrapper">
                              <div class="personal-info-container mt-5" :style="item.personalInformation ? 'background: #FFF2F2' : 'background: #EDEDED'">
                                <div class="personal-info-header">
                                  <div
                                    class="personal-info-label cursor-pointer"
                                  >
                                    <v-img class="mr-2" :src="item.personalInformation ? images.vector : images.vectorinactive" width="18" height="18"></v-img>
                                    <span class="text-caption">
                                      {{ $t('personalInfo') }}:
                                      <span
                                        :class="
                                          item.personalInformation
                                            ? 'status-on'
                                            : 'status-off'
                                        "
                                      >
                                        {{
                                          item.personalInformation
                                            ? $t('on')
                                            : $t('off')
                                        }}
                                      </span>
                                    </span>
                                  </div>
                                    
                                  <v-tooltip location="top" max-width="300px">
                                    <template v-slot:activator="{ props }">
                                      <span v-bind="props" class="switch-tooltip-wrapper">
                                        <v-switch
                                          v-model="item.personalInformation"
                                          id="personalinfo-edit-databaseintegration"
                                          inset
                                          density="compact"
                                          color="#C32E0E"
                                          hide-details
                                          class="personal-info-switch"
                                          :class="[
                                                'publication-toggle',
                                                item.personalInformation
                                                  ? 'publication-toggle--active'
                                                  : 'publication-toggle--inactive'
                                              ]"
                                          :disabled="
                                          (item.typeId == '' || item.typeId == null)
                                          ||
                                            item.typeId != null &&
                                            item.typeId.toLowerCase() !=
                                              'nvarchar' &&
                                            item.typeId.toLowerCase() != 'text' &&
                                            item.typeId.toLowerCase() !=
                                              'varchar' &&
                                            item.typeId.toLowerCase() !=
                                              'varchar2' &&
                                            item.typeId.toLowerCase() != 'char' &&
                                            item.typeId.toLowerCase() != 'nchar'
                                          "
                                        ></v-switch>
                                      </span>
                                    </template>
                                    <span>{{ $t('_personalInfoTooltip') }}</span>
                                  </v-tooltip>

                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Add Column Button -->
                <v-row v-if="type == 'E'" class="add-column-row">
                  <v-col cols="12">
                    <v-btn
                      id="detail-E-button-addcolumn-dataitegration"
                      variant="outlined"
                      color="primary"
                      block
                      @click="AddColumn()"
                      class="add-column-btn"
                    >
                      <v-icon class="mr-2">mdi-plus-circle</v-icon>
                      {{ $t('addColumn') }}
                      <v-tooltip location="top" activator="parent">
                        <span>{{ $t('_addColumnTooltip') }}</span>
                      </v-tooltip>
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- Action Buttons -->
                <div class="config-action-buttons d-flex justify-end mt-4">
                  <v-btn
                    id="detail-button-close-dataitegration"
                    variant="outlined"
                    color="grey-darken-1"
                    @click="back()"
                    class="config-action-btn confirm-btn"
                  >
                    <v-icon class="mr-1">mdi-close</v-icon>
                    {{ $t("close") }}
                  </v-btn>
                  <v-btn
                    id="detail-button-save-dataitegration"
                    variant="elevated"
                    @click="Save()"
                    class="config-action-btn savebtn confirm-btn ml-4"
                  >
                    <v-img :src="images.savebtn" width="20" height="20" class="mr-2" />
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title
              id="detail-data-dataintegration"
              class="custom-expansion-title"
            >
              <template v-slot:actions="{ expanded }">
                <v-icon
                  :style="{
                    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  }"
                  class="expansion-icon"
                  size="35"
                >
                  mdi-menu-down
                </v-icon>
              </template>
              <div class="expansion-title-content">
                <span class="expansion-header">{{ $t('records') }}</span>
              </div>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <div class="record-detail-container">
                <v-row no-gutters class="mt-2">
                  <v-col cols="4" v-if="DataCol.length > 0 && type == 'I'">
                    <!-- Search Field Container -->
                    <div class="search-field-container">
                      <!-- Float Type Search -->
                      <v-text-field
                        v-if="DataCol[0].typeId == 'float' && type == 'I'"
                        v-model="Search"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                        class="search-field modern-input"
                        append-inner-icon="mdi-magnify"
                        :placeholder="$t('search')"
                        color="red-darken-4"
                        @keypress="isNumber($event)"
                        @keydown.enter="GetSearch"
                      />

                      <!-- Integer Type Search -->
                      <v-text-field
                        id="detail-I-fieldShearch-dataintegration"
                        v-else-if="DataCol[0].typeId == 'int' && type == 'I'"
                        v-model="Search"
                        variant="outlined"
                        density="compact"
                        :placeholder="$t('search')"
                        clearable
                        hide-details="auto"
                        class="search-field modern-input"
                        append-inner-icon="mdi-magnify"
                        color="red-darken-4"
                        @keypress="isNumberpositive($event)"
                        @keydown.enter="GetSearch"
                      />

                      <!-- String/Bit Type Search -->
                      <v-text-field
                        v-else-if="
                          (DataCol[0].typeId == 'nvarchar' ||
                            DataCol[0].typeId == 'bit') &&
                          type == 'I'
                        "
                        v-model="Search"
                        variant="outlined"
                        density="compact"
                        :placeholder="$t('search')"
                        clearable
                        color="red-darken-4"
                        hide-details="auto"
                        class="search-field modern-input"
                        append-inner-icon="mdi-magnify"
                        @keydown.enter="GetSearch"
                      />

                      <!-- DateTime Type Search -->
                      <v-menu
                        v-model="AddDateFlag"
                        v-else-if="
                          DataCol[0].typeId == 'datetime' && type == 'I'
                        "
                        :close-on-content-click="false"
                        transition="scale-transition"
                        location="bottom start"
                        min-width="auto"
                        class="modern-input"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            id="detail-search-dataintegration"
                            v-model="Search"
                            :label="
                              DataCol.length > 0 ? DataCol[0].newCol : $t('search')
                            "
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            density="compact"
                            clearable
                            hide-details="auto"
                            v-bind="props"
                            class="search-field date-field modern-input"
                            @keydown.enter="GetSearch"
                          />
                        </template>
                        <v-date-picker
                          id="detail-button-search-dataintegration"
                          v-model="Search"
                          @update:model-value="
                            (val) => {
                              Search = formatDate(val);
                              AddDateFlag = false;
                            }
                          "
                          elevation="8"
                          rounded="lg"
                        />
                      </v-menu>
                    </div>
                  </v-col>

                  <v-row>
                    <v-col cols="5" v-if="type == 'I'">
                    </v-col>
                    <v-col
                      cols="7"
                      class="d-flex justify-end mt-4"
                      v-if="type == 'I'"
                    >
                      <div class="control-group" style="margin-top: -25px">
                        <v-btn
                          id="detail-button-upload-proxy"
                          variant="elevated"
                          class="upload-proxy-btn"
                          @click="triggerFileUpload"
                        >
                          <v-img :src="images.importbtn" width="20" height="20" class="mr-2" />
                          {{ $t('import') }}
                        </v-btn>

                        <!-- Hidden DragDropFile Component -->
                        <DragDropFile
                          ref="dragDropFileRef"
                          id="detail-button-uploadfile-dataintegration"
                          :dialog="true"
                          :DragDrop="false"
                          :ShowListFile="false"
                          :accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                          @filesUploaded="processUpload($event)"
                          :allowType="[]"
                          class="upload-file-btn hidden-upload"
                        />
                        <div class="add-action-container">
                          <v-btn
                            id="detail-I-button-adddata-dataintegration"
                            size="large"
                            class="add-btn"
                            flat
                            @click="triggerReplaceAllUpload"
                          >
                            <v-img :src="images.replaceall" width="20" height="20" class="mr-2" />
                            {{ $t('replaceAll') }}
                          </v-btn>

                          <!-- Hidden DragDropFile Component for Replace All -->
                          <DragDropFile
                            ref="replaceAllFileRef"
                            id="detail-button-replaceall-dataintegration"
                            :dialog="true"
                            :DragDrop="false"
                            :ShowListFile="false"
                            :accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                            @filesUploaded="processUpload($event)"
                            :allowType="[]"
                            class="upload-file-btn hidden-upload"
                          />
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-card elevation="2" class="data-table-card">
                      <v-data-table
                        :items-per-page="options.itemsPerPage"
                        :loading="loadingTable"
                        :items-length="searchTotalTable"
                        v-model:options="options"
                        :headers="headers"
                        :items="dataTable"
                        class="modern-table"
                        :hover="true"
                        :fixed-header="true"
                      >
                        <!-- Loading Template -->
                        <template v-slot:loading>
                          <v-skeleton-loader
                            type="table-row@10"
                          ></v-skeleton-loader>
                        </template>

                        <!-- No Data Template -->
                        <template v-slot:no-data>
                          <div class="text-center pa-8">
                            <v-icon size="64" color="grey-lighten-2"
                              >mdi-database-off</v-icon
                            >
                            <div class="text-h6 text-grey-darken-1 mt-4">
                              {{ $t('noDataAvailable') }}
                            </div>
                            <div class="text-body-2 text-grey">
                              {{ $t('_tryDifferentSearch') }}
                            </div>
                          </div>
                        </template>

                        <!-- Header Template -->
                        <template v-slot:headers="{ columns }">
                          <tr class="table-header-row">
                            <th
                              scope="col"
                              v-for="column in columns"
                              :key="column.key"
                              class="table-header-cell"
                              :class="{
                                'text-center': column.align === 'center',
                              }"
                            >
                              <div class="header-content">
                                <span class="header-text">{{
                                  column.title
                                }}</span>
                              </div>
                            </th>
                          </tr>
                        </template>

                        <!-- Item Template -->
                        <template v-slot:item="{ item, index }">
                          <tr
                            :key="index + 'tr'"
                            class="table-row"
                            :class="{ 'row-hover': true }"
                          >
                            <td
                              v-for="(value, i) in item"
                              :key="i + 'td'"
                              class="table-cell"
                              :class="{
                                'text-center': headers[i]?.align === 'center',
                              }"
                            >
                              <div class="cell-content">
                                <span class="cell-text" :title="value">
                                  {{ value }}
                                </span>
                              </div>
                            </td>

                            <!-- Action Column -->
                            <td
                              v-if="type == 'I'"
                              class="table-cell text-center action-cell"
                            >
                              <div class="action-buttons">
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                <v-btn
                                  :id="
                                    'detail-I-button-editdata-dataintegration-' +
                                    index
                                  "
                                  variant="text"
                                  class="datatable-action-btn edit-btn mr-3"
                                  v-bind="props"
                                  @click="EditData(item)"
                                >
                                  <v-img :src="images.editBtn" width="20" height="20" />
                                </v-btn>
                                </template>
                                  <span>{{ $t("edit") }}</span>
                                </v-tooltip>

                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-btn
                                      :id="
                                        'detail-I-button-deletedata-dataintegration-' +
                                        index
                                      "
                                      variant="text"
                                      class="datatable-action-btn delete-btn"
                                      v-bind="props"
                                      @click="DeleteData(item)"
                                    >
                                      <v-img :src="images.deleteBtn" width="20" height="20" />
                                    </v-btn>
                                  </template>
                                  <span>{{ $t("delete") }}</span>
                                </v-tooltip>
                              </div>
                            </td>
                          </tr>
                        </template>
                        
                        <!-- Custom Footer for v-data-table -->
                        <template v-slot:bottom>
                          <!-- Add "New Record" button after last item -->
                          <v-btn class="addrecord" v-if="importMode == 'Internal'" @click="AddNewRecord(false)" variant="outlined" flat>
                            <v-icon left>mdi-plus</v-icon>
                              {{ $t('newRecord') }}
                          </v-btn>
                          <div class="custom-footer">
                            <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

                            <div class="d-flex">
                              <div class="footer-left">
                              <span>{{ $t('itemsPerPage') }}</span>
                              <v-select
                                v-model="options.itemsPerPage"
                                :items="[5, 10, 15, 20]"
                                dense
                                hide-details
                                variant="outlined"
                                density="compact"
                                style="width: 80px; margin-left: 8px;"
                                class="footerPerpage"
                              ></v-select>
                            </div>
                            <div class="footer-center">
                              <span>
                                {{
                                  (options.page - 1) * options.itemsPerPage + 1
                                }}-
                                {{
                                  Math.min(
                                    options.page * options.itemsPerPage,
                                    searchTotalTable
                                  )
                                }}
                                {{ $t('of') }} {{ searchTotalTable }}
                              </span>
                            </div>
                            <div class="footer-right">
                              <div
                                style="
                                  background-color: transparent !important;
                                  box-shadow: none;
                                "
                                icon
                              >
                                <v-icon
                                  style="min-width: 50px"
                                  @click="options.page = 1"
                                  :disabled="options.page === 1"
                                  :class="
                                    options.page === 1
                                      ? 'transparent-disabled'
                                      : 'transparent-enabled'
                                  "
                                  >mdi-page-first</v-icon
                                >
                              </div>
                              <div
                                style="
                                  background-color: transparent;
                                  box-shadow: none;
                                "
                                icon
                              >
                                <v-icon
                                  style="min-width: 50px"
                                  @click="options.page--"
                                  :disabled="options.page === 1"
                                  :class="
                                    options.page === 1
                                      ? 'transparent-disabled'
                                      : 'transparent-enabled'
                                  "
                                  >mdi-chevron-left</v-icon
                                >
                              </div>
                              <div
                                style="
                                  background-color: transparent;
                                  box-shadow: none;
                                "
                                icon
                              >
                                <v-icon
                                  style="min-width: 50px"
                                  @click="options.page++"
                                  :disabled="
                                    options.page >=
                                    Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                  "
                                  :class="
                                    options.page >=
                                    Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                      ? 'transparent-disabled'
                                      : 'transparent-enabled'
                                  "
                                  >mdi-chevron-right</v-icon
                                >
                              </div>
                              <div
                                style="
                                  background-color: transparent;
                                  box-shadow: none;
                                "
                                icon
                              >
                                <v-icon
                                  style="min-width: 50px"
                                  @click="
                                    options.page = Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                  "
                                  :disabled="
                                    options.page >=
                                    Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                  "
                                  :class="
                                    options.page >=
                                    Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                      ? 'transparent-disabled'
                                      : 'transparent-enabled'
                                  "
                                  >mdi-page-last</v-icon
                                >
                              </div>
                            </div>
                            </div>
                            
                          </div>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
        <br />
      </v-card>
    </v-container>
    <v-dialog v-model="Adddialog" max-width="800" persistent class="modern-dialog">
      <v-card class="dialog-card" elevation="8" rounded="xl">
        <!-- Enhanced Header -->
        <div class="dialog-header">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title1" style="color: white;">{{ $t('addNewRecord') }}</h2>
              <p class="dialog-subtitle1" style="color: white;">{{ $t('_addNewRecordSubtitle') }}</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              class="close-button"
              @click="
                Adddialog = false;
                NewDataDetail = [];
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

        </div>

        <!-- Enhanced Content -->
        <v-card-text>
            <v-form ref="addDetailForm" class="mt-5">
            <v-row class="form-grid">
              <v-col
                cols="12"
                sm="12"
                md="6"
                v-for="(item, id) in DataCol"
                :key="id"
                class="form-column"
              >
                <!-- Field Container -->
                <div class="field-container">
                  <div class="field-group">
                  <label
                    :for="'detail-editdatatype-float-dataintegration-' + id"
                    class="field-label"
                  >
                    {{ item.newCol }}
                    <span v-if="rules.required" class="required">*</span>
                  </label>
                </div>
                  <!-- Float Type Field -->
                  <v-text-field
                    v-if="item.typeId == 'float'"
                    :id="'detail-newdatatype-float-dataintegration-' + id"
                    :placeholder="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field modern-input"
                    @keypress="isNumber($event)"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Integer Type Field -->
                  <v-text-field
                    v-else-if="item.typeId == 'int'"
                    :id="'detail-newdatatype-int-dataintegration-' + id"
                    :placeholder="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field modern-input"
                    @keypress="isNumberpositive($event)"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Text Type Field -->
                  <v-text-field
                    v-else-if="item.typeId == 'nvarchar'"
                    :id="'detail-newdatatype-nvarchar-dataintegration-' + id"
                    :placeholder="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field modern-input"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Boolean Select Field -->
                  <v-select
                    v-else-if="item.typeId == 'bit'"
                    :id="'detail-newdatatype-bit-dataintegration' + id"
                    :placeholder="item.newCol"
                    v-model="NewDataDetail[id]"
                    :items="[
                      { text: 'True', value: 'True' },
                      { text: 'False', value: 'False' },
                    ]"
                    item-title="text"
                    item-value="value"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field modern-input"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Date Field -->
                  <v-menu
                    v-else-if="item.typeId == 'datetime'"
                    :id="'detail-newdatatype-date-dataintegration-' + id"
                    v-model="AddDateFlag"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    location="bottom start"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="NewDataDetail[id]"
                        :placeholder="item.newCol"
                        readonly
                        variant="outlined"
                        density="comfortable"
                        clearable
                        v-bind="props"
                        class="modern-field date-field mordern-input"
                        :rules="[rules.required]"
                        hide-details="auto"
                      />
                    </template>
                    <v-date-picker
                      id="detail-button-addDateFlag-dataintegration"
                      v-model="NewDataDetail[id]"
                      format="yyyy-MM-dd"
                      @update:model-value="
                        (val) => {
                          NewDataDetail[id] = formatDate(val);
                          AddDateFlag = false;
                        }
                      "
                      elevation="8"
                      rounded="lg"
                      class="modern-date-picker modern-input"
                    />
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <!-- Enhanced Divider -->
        <v-divider class="modern-divider"></v-divider>

        <!-- Enhanced Actions -->
        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn
                id="detail-button-close-datadetail-dataintegration"
                variant="outlined"
                color="grey-darken-1"
                size="large"
                class="dialog-action-btn cancel-btn"
                @click="
                  Adddialog = false;
                  NewDataDetail = [];
                "
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t('close') }}
              </v-btn>
              
              <v-btn 
                id="detail-button-saveadddetail-dataintegration" 
                variant="elevated" 
                
                size="large"
                class="dialog-action-btn savebtn"
                @click="SaveAddDetail()"
              >
                <v-img :src="images.savebtn" width="20" height="20" class="mr-2" />
                {{ $t('save') }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="Editdialog" max-width="800" persistent class="modern-dialog">
      <v-card class="dialog-card" elevation="8" rounded="xl">
        <!-- Enhanced Header -->
        <v-card-title class="dialog-header dialog-header-edit1">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title1" style="color: white">{{ $t('editRecord') }}</h2>
              <p class="dialog-subtitle1" style="color: white">{{ $t('_editRecordSubtitle') }}</p>
            </div>
          </div>
        </v-card-title>

        <!-- Enhanced Content -->
        <v-card-text>
          <v-form ref="editDetailForm" class="mt-5">
            <v-row class="form-grid">
              <v-col
                cols="12"
                sm="12"
                md="6"
                v-for="(item, id) in DataCol"
                :key="id"
                class="form-column"
              >
                <!-- Field Container -->
                <div class="field-container">
                  <!-- Float Type Field -->
                   <div class="field-group">
                    <label
                      :for="'detail-editdatatype-float-dataintegration-' + id"
                      class="field-label"
                    >
                      {{ item.newCol }}
                      <span v-if="rules.required" class="required">*</span>
                    </label>
                  </div>
                  <v-text-field
                    v-if="item.typeId == 'float'"
                    :id="'detail-editdatatype-float-dataintegration-' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field modern-input"
                    @keypress="isNumber($event)"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Integer Type Field -->
                  <v-text-field
                    v-else-if="item.typeId == 'int'"
                    :id="'detail-editdatatype-int-dataintegration-' + id"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field modern-input"
                    @keypress="isNumberpositive($event)"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Text Type Field -->
                  <v-text-field
                    v-else-if="item.typeId == 'nvarchar'"
                    :id="'detail-editdatatype-nvarchar-dataintegration-' + id"
                    
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field modern-input"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Boolean Select Field -->
                  <v-select
                    v-else-if="item.typeId == 'bit'"
                    :id="'detail-editdatatype-bit-dataintegration' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    :items="[
                      { text: 'True', value: 'True' },
                      { text: 'False', value: 'False' },
                    ]"
                    item-title="text"
                    item-value="value"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-toggle-switch"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Date Field -->
                  <v-menu
                    v-else-if="item.typeId == 'datetime'"
                    :id="'detail-editdatatype-date-dataintegration-' + id"
                    v-model="EditDateFlag"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    location="bottom start"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="NewDataDetail[id]"
                        :label="item.newCol"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        variant="outlined"
                        density="comfortable"
                        clearable
                        v-bind="props"
                        class="modern-field date-field modern-input"
                        :rules="[rules.required]"
                        hide-details="auto"
                      />
                    </template>

                    <v-date-picker
                      v-model="NewDataDetail[id]"
                      format="YYYY-MM-DD"
                      @update:model-value="
                        (val) => {
                          NewDataDetail[id] = formatDate(val);
                          EditDateFlag = false;
                        }
                      "
                      elevation="8"
                      rounded="lg"
                      class="modern-date-picker"
                    />
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <!-- Enhanced Divider -->
        <v-divider class="modern-divider"></v-divider>

        <!-- Enhanced Actions -->
         <div class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn
              variant="outlined"
              color="grey-darken-1"
              size="large"
              class="dialog-action-btn cancel-btn"
              @click="closeEditDialog()"
            >
              <v-icon class="mr-2">mdi-close</v-icon>
              {{ $t("close") }}
            </v-btn>
              <v-btn 
              variant="elevated" 
              color="primary"
              size="large"
              class="dialog-action-btn savebtn"
              @click="SaveEdit()"
            >
              <v-img :src="images.savebtn" class="mr-2" width="16" height="16"></v-img>
              {{ $t("save") }}
            </v-btn>
            </div>
          </div>
         </div>
      </v-card>
    </v-dialog>
    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            {{ $t('_loadingPleaseWait') }}
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <!-- Custom Confirmation Dialog -->
    <v-dialog v-model="confirmDialog.show" width="auto" min-width="550" persistent class="confirm-dialog">
      <v-card class="confirm-card" elevation="8">
        <!-- Header -->
        <v-card-title class="confirm-header" :class="confirmDialog.type + '-header'">
          <div class="confirm-title-text">
            <h3>{{ confirmDialog.title }}</h3>
          </div>
        </v-card-title>

        <!-- Content -->
        <v-card-text class="confirm-content" v-if="confirmDialog.text">
          <p class="confirm-message">{{ confirmDialog.text }}</p>
        </v-card-text>
        <v-divider></v-divider>
        <!-- Actions -->
        <v-card-actions class="confirm-actions" v-if="!confirmDialog.autoClose">
          <v-spacer></v-spacer>
          <v-btn
            v-if="confirmDialog.showCancel"
            variant="outlined"
            color="grey-darken-1"
            class="confirm-btn"
            @click="handleConfirmCancel"
          >
            {{ confirmDialog.cancelText || $t('cancel') }}
          </v-btn>
          <v-btn
            variant="elevated"
            :color="getConfirmColor(confirmDialog.type)"
            class="confirm-btn confirm-btn-primary"
            @click="handleConfirmOk"
          >
            <v-icon class="mr-2">{{ getConfirmActionIcon(confirmDialog.type) }}</v-icon>
            {{ confirmDialog.confirmText || $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import DragDropFile from "@/components/DragDropFile.vue";
import ExcelJS from "exceljs";

import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/images/trash-solid.svg";
import tableImg from "@/assets/images/table.png";
import vector from '@/assets/images/Vector.png';
import vectorinactive from '@/assets/images/Vectorinactive.png';
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import savebtn from '@/assets/images/savecard.png';
import importbtn from '@/assets/images/fileimport.png';
import replaceall from '@/assets/images/replaceall.png';
import column from '@/assets/Icons/Columns.png';

export default {
  name: "DataIntegrationDetail",
  components: { DragDropFile },
  mixins: [checkPermissionTwo],
  inject:["FontColorTitle","SubNavbarBackGround"],
  data: () => ({
    allowOptionWatch: false,
    options: {},
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    headers: [],
    Search: "",
    id: null,
    panel: [1],
    dialog: false,
    loadingTable: false,
    Adddialog: false,
    Editdialog: false,
    AddDateFlag: false,
    EditDateFlag: false,
    // valid: true,
    // tempID: 0,
    today: null,
    loading: true,
    DataCol: [],
    DataIntegrationName: null,
    OldDataDetail: [],
    NewDataDetail: [],
    type: null,
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    DataRowUpload: [],
    images: {
      edit: editImg,
      delete: deleteImg,
      tableImg: tableImg,
      vector: vector,
      vectorinactive: vectorinactive,
      editBtn: editBtn,
      deleteBtn: deleteBtn,
      savebtn: savebtn,
      importbtn: importbtn,
      replaceall: replaceall,
      column: column,
    },
    DDDataType: [
      {
        id: "nvarchar",
        name: "nvarchar",
      },
      {
        id: "int",
        name: "int",
      },
      {
        id: "float",
        name: "float",
      },
      {
        id: "datetime",
        name: "datetime",
      },
      {
        id: "bit",
        name: "bit",
      },
    ],
    modeType: [
      {
        name: "Add",
        value: false,
      },
      {
        name: "Replace",
        value: true,
      },
    ],
    deleteAll: false,
    Entity: null,
    uploadedFiles: [],
    files: [],
    confirmDialog: {
      show: false,
      type: 'info', // success, error, warning, info
      title: '',
      text: '',
      showCancel: false,
      confirmText: '',
      cancelText: '',
      autoClose: false,
      timer: null,
      resolve: null
    },
    errorMessages: {
      columns: []
    },
    validatingColumnIndex: null,
    importMode: '',
  }),
  computed: {
    fuzzyOptions() {
      return [
        {
          text: this.$t('none'),
          value: "none",
          description: this.$t('_fuzzyNoneDesc'),
          icon: "mdi-close-circle-outline",
          color: "grey",
        },
        {
          text: this.$t('fuzzySearch'),
          value: "fuzzy",
          description: this.$t('_fuzzySearchDesc'),
          icon: "mdi-magnify",
          color: "primary",
        },
        {
          text: this.$t('fuzzyWithBot'),
          value: "fuzzyBot",
          description: this.$t('_fuzzyBotDesc'),
          icon: "mdi-robot",
          color: "success",
        },
      ];
    },
    rules() {
      return {
        required: (value) => !!value || this.$t('requiredField'),
      };
    },
  },
  watch: {
    options: {
      handler() {
        if (this.allowOptionWatch) {
          this.GetTable();
        }
      },
      deep: true,
    },
  },
  methods: {
    getFuzzyValue(item) {
      if (item.fuzzy) return "fuzzy";
      if (item.fuzzyBot) return "fuzzyBot";
      return "none";
    },

      triggerReplaceAllUpload() {
      //Set deleteAll to true for replace all functionality
      this.deleteAll = true;
      
      if (this.$refs.replaceAllFileRef) {
        const fileInput = this.$refs.replaceAllFileRef.$el.querySelector('input[type="file"]');
        const uploadButton = this.$refs.replaceAllFileRef.$el.querySelector("button");

        if (fileInput) {
          fileInput.click();
        } else if (uploadButton) {
          uploadButton.click();
        }
      }
    },
 
      triggerFileUpload() {
        // false for import functionality (add without deleting)
        this.deleteAll = false;
        if (this.$refs.dragDropFileRef) {
          const fileInput = this.$refs.dragDropFileRef.$el.querySelector('input[type="file"]');
          const uploadButton = this.$refs.dragDropFileRef.$el.querySelector("button");

          if (fileInput) {
            fileInput.click();
          } else if (uploadButton) {
            uploadButton.click();
          }
        }
      },

    setFuzzyValue(item, value) {
      // Set the selected option
      if (value === "fuzzy") {
        item.fuzzy = true;
        item.fuzzyBot = false;
      } else if (value === "fuzzyBot") {
        item.fuzzy = false;
        item.fuzzyBot = true;
      }else{
        // Reset all fuzzy options
        item.fuzzy = false;
        item.fuzzyBot = false;
      }
    },

    getFuzzyIcon(itemOrOption) {
      if (itemOrOption.icon) return itemOrOption.icon; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return "mdi-magnify";
      if (itemOrOption.fuzzyBot) return "mdi-robot";
      return "mdi-close-circle-outline";
    },

    getFuzzyColor(itemOrOption) {
      if (itemOrOption.color) return itemOrOption.color; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return "primary";
      if (itemOrOption.fuzzyBot) return "success";
      return "grey";
    },
    toggleFuzzy(item) {
      // ตรวจสอบว่าสามารถคลิฝได้หรือไม่
      if (this.type == "I" && item.typeId != "nvarchar") {
        return;
      }

      // Toggle fuzzy ๝ละปิด fuzzyBot (เพื่อให้ทำงาน๝บบ radio)
      item.fuzzy = !item.fuzzy;
      if (item.fuzzy) {
        item.fuzzyBot = false;
      }
    },

    toggleFuzzyBot(item) {
      // ตรวจสอบว่าสามารถคลิฝได้หรือไม่
      if (this.type == "I" && item.typeId != "nvarchar") {
        return;
      }

      // Toggle fuzzyBot ๝ละปิด fuzzy (เพื่อให้ทำงาน๝บบ radio)
      item.fuzzyBot = !item.fuzzyBot;
      if (item.fuzzyBot) {
        item.fuzzy = false;
      }
    },

    // Custom dialog methods
    showDialog(options) {
      return new Promise((resolve) => {
        this.confirmDialog = {
          show: true,
          type: options.icon || 'info',
          title: options.title || '',
          text: options.text || '',
          showCancel: options.showCancelButton || false,
          confirmText: options.confirmButtonText || this.$t('confirm'),
          cancelText: options.cancelButtonText || this.$t('cancel'),
          autoClose: Boolean(options.timer),
          resolve: resolve
        };

        if (options.timer) {
          this.confirmDialog.timer = setTimeout(() => {
            this.closeDialog();
            resolve({ isConfirmed: false });
          }, options.timer);
        }
      });
    },

    handleConfirmOk() {
      if (this.confirmDialog.timer) {
        clearTimeout(this.confirmDialog.timer);
      }
      const resolve = this.confirmDialog.resolve;
      this.closeDialog();
      if (resolve) resolve({ isConfirmed: true });
    },

    handleConfirmCancel() {
      if (this.confirmDialog.timer) {
        clearTimeout(this.confirmDialog.timer);
      }
      const resolve = this.confirmDialog.resolve;
      this.closeDialog();
      if (resolve) resolve({ isConfirmed: false });
    },

    closeDialog() {
      this.confirmDialog.show = false;
      this.confirmDialog.resolve = null;
      if (this.confirmDialog.timer) {
        clearTimeout(this.confirmDialog.timer);
        this.confirmDialog.timer = null;
      }
    },

    showValidationSwal(options) {
      const isSuccess = options.icon === 'success';
      const isWarning = options.icon === 'warning';
      const defaultConfirmButtonColor = isWarning ? '#F59E0B' : '#C32E0E';

      return this.fireSwalPreservingScroll({
        icon: options.icon,
        title: options.title,
        text: options.html ? undefined : options.text,
        html: options.html,
        timer: options.timer,
        timerProgressBar: Boolean(options.timer),
        toast: Boolean(options.toast),
        position: options.position || (isSuccess ? 'top-end' : 'center'),
        showCancelButton: Boolean(options.showCancelButton),
        showConfirmButton: options.showConfirmButton ?? !options.timer,
        confirmButtonText: options.confirmButtonText || this.$t('close'),
        cancelButtonText: options.cancelButtonText || this.$t('cancel'),
        confirmButtonColor: options.confirmButtonColor || (isSuccess ? '#2ABF56' : defaultConfirmButtonColor),
        cancelButtonColor: options.cancelButtonColor || '#9CA3AF',
        showCloseButton: options.showCloseButton ?? !isSuccess,
        focusConfirm: false,
        returnFocus: false,
        heightAuto: false,
        scrollbarPadding: false,
        reverseButtons: Boolean(options.showCancelButton),
        customClass: {
          popup: 'rounded-lg',
        },
      });
    },

    getViewportScrollPosition() {
      return {
        left: window.pageXOffset || window.scrollX || 0,
        top: window.pageYOffset || window.scrollY || 0,
      };
    },

    restoreViewportScrollPosition(scrollPosition) {
      if (!scrollPosition) {
        return;
      }

      const restore = () => window.scrollTo({
        left: scrollPosition.left,
        top: scrollPosition.top,
        behavior: 'auto',
      });

      globalThis.requestAnimationFrame(restore);
      globalThis.setTimeout(restore, 0);
    },

    fireSwalPreservingScroll(options = {}) {
      const scrollPosition = this.getViewportScrollPosition();
      const originalDidOpen = options.didOpen;
      const originalWillClose = options.willClose;
      const originalDidClose = options.didClose;

      return this.$swal.fire({
        ...options,
        didOpen: (popup) => {
          this.restoreViewportScrollPosition(scrollPosition);
          if (typeof originalDidOpen === 'function') {
            originalDidOpen(popup);
          }
        },
        willClose: (popup) => {
          this.restoreViewportScrollPosition(scrollPosition);
          if (typeof originalWillClose === 'function') {
            originalWillClose(popup);
          }
        },
        didClose: () => {
          this.restoreViewportScrollPosition(scrollPosition);
          if (typeof originalDidClose === 'function') {
            originalDidClose();
          }
        },
      }).then((result) => {
        this.restoreViewportScrollPosition(scrollPosition);
        return result;
      });
    },

    showTopStatusBanner(title, options = {}) {
      const statusType = options.statusType || (options.isError ? 'error' : 'success');
      const prefixMap = {
        success: '✔',
        error: '✖',
        warning: '⚠',
      };
      const popupClassMap = {
        success: 'success-banner',
        error: 'error-banner',
        warning: 'warning-banner',
      };
      const titleClassMap = {
        success: 'success-banner-title',
        error: 'error-banner-title',
        warning: 'warning-banner-title',
      };
      const prefix = options.prefix || prefixMap[statusType] || '✔';

      this.fireSwalPreservingScroll({
        title: `${prefix} ${title}`,
        showConfirmButton: false,
        timer: options.timer || 1500,
        position: 'top',
        backdrop: false,
        allowOutsideClick: true,
        allowEscapeKey: true,
        heightAuto: false,
        returnFocus: false,
        scrollbarPadding: false,
        customClass: {
          popup: popupClassMap[statusType] || 'success-banner',
          title: titleClassMap[statusType] || 'success-banner-title',
        },
      });
    },

    showTopStatusWarning(title, timer = 4000) {
      this.showTopStatusBanner(title, {
        statusType: 'warning',
        timer,
      });
    },

    showTopStatusError(title, timer = 2500) {
      this.showTopStatusBanner(title, {
        statusType: 'error',
        timer,
      });
    },

    escapeHtml(value) {
      return String(value ?? '').replace(/[&<>"']/g, (character) => {
        const entities = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        };

        return entities[character] || character;
      });
    },

    buildSwalMessageHtml(lines, options = {}) {
      const filteredLines = lines.filter((line) => Boolean(line && String(line).trim()));
      const textAlign = options.align || 'left';
      const emphasisIndex = options.emphasisIndex ?? -1;

      return `
        <div style="text-align: ${textAlign}; line-height: 1.6;">
          ${filteredLines
            .map((line, index) => {
              const isEmphasis = index === emphasisIndex;
              return `<p style="margin: 0 0 10px; color: ${isEmphasis ? '#C32E0E' : '#374151'}; font-weight: ${isEmphasis ? '700' : '400'};">${this.escapeHtml(line)}</p>`;
            })
            .join('')}
        </div>
      `;
    },

    truncateText(value, maxLength = 100) {
      const text = String(value ?? '');
      if (text.length <= maxLength) {
        return text;
      }

      return `${text.substring(0, maxLength)}...`;
    },

    getSaveSchemaErrorContent(message) {
      const rawMessage = String(message ?? '').trim();
      const normalizedMessage = rawMessage.toLowerCase();

      if (normalizedMessage.includes('source schema/table') || normalizedMessage.includes('schema and table not found')) {
        return {
          title: this.$t('_sourceSchemaNotFound'),
          html: this.buildSwalMessageHtml(
            [
              this.truncateText(rawMessage),
              this.$t('_sourceSchemaNotFoundLine1'),
              this.$t('_sourceSchemaNotFoundLine2'),
            ],
            {
              align: 'center',
              emphasisIndex: 0,
            }
          ),
        };
      }

      if (normalizedMessage.includes('was not found in the source schema')) {
        return {
          title: this.$t('_schemaChangedDuringSave'),
          html: this.buildSwalMessageHtml(
            [
              this.truncateText(rawMessage),
              this.$t('_schemaChangedLine1'),
              this.$t('_schemaChangedLine2'),
            ],
            {
              align: 'center',
              emphasisIndex: 0,
            }
          ),
        };
      }

      return {
        title: this.$t('saveFailed'),
        html: this.buildSwalMessageHtml(
          [
            this.truncateText(rawMessage || this.$t('_unableToSaveSchema')),
            this.$t('_verifySchemaTryAgain'),
          ],
          {
            align: 'center',
            emphasisIndex: 0,
          }
        ),
      };
    },

    syncSchemaStateAfterSave() {
      const updatedColumns = this.DataCol.map((item) => ({
        ...item,
        col: item.newCol || item.col,
      }));

      this.DataCol = updatedColumns;
      this.headers = updatedColumns.map((item) => ({
        title: item.newCol || item.col,
        align: 'center',
        sortable: false,
      }));

      if (this.type == 'I') {
        this.headers.push({
          title: this.$t('manage'),
          align: 'center',
          sortable: false,
        });
      }

      this.errorMessages.columns = updatedColumns.map(() => ({
        error: false,
        message: '',
      }));
    },

    focusColumnInput(index) {
      this.$nextTick(() => {
        const input = document.querySelector(`#detail-configuration-column-dataintegration-${index} input`);
        if (!input) {
          return;
        }

        try {
          input.focus({ preventScroll: true });
        } catch (error) {
          console.error(error);
          // preventScroll option unsupported; fall back to default focus
          input.focus();
        }
      });
    },

    getConfirmIcon(type) {
      const icons = {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        warning: 'mdi-alert',
        info: 'mdi-information',
        delete: 'mdi-trash-can-outline'
      };
      return icons[type] || icons.info;
    },

    getConfirmColor(type) {
      const colors = {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'primary',
        delete: '#C30000'
      };
      return colors[type] || colors.info;
    },

    getConfirmActionIcon(type) {
      const icons = {
        success: 'mdi-check',
        error: 'mdi-close',
        warning: 'mdi-check',
        info: 'mdi-check',
        delete: 'mdi-trash-can-outline'
      };
      return icons[type] || icons.info;
    },

    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (Number.isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    back() {
        this.$router.push({
        name: "DataIntegration",
      });
    },
    async Get() {
        this.dialog = true;
        this.$call.GetDataIntegrationDetail(
          this.id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
              this.DataIntegrationName = dataResponse.data.dataName;
              this.DataCol = dataResponse.data.dataJson;
              this.type = dataResponse.data.type;
              this.headers = dataResponse.data.dataJson.map((e) => ({
              title: e.newCol || e.col,
              align: "center",
              sortable: false,
            }));
              if (this.type == "I") {
                this.headers.push({
                  title: this.$t("manage"),
                align: "center",
                sortable: false,
              });
            }
              this.GetTable();
          }
            this.dialog = false;
        },
        (errorResource) => {
            this.dialog = false;
          console.error(errorResource);
        }
      );
    },

    normalizeDetailDateColumns() {
      const indexDateTime = [];
      for (let i = 0; i < this.DataCol.length; i++) {
        if (this.DataCol[i].typeId == "datetime") {
          indexDateTime.push(i);
        }
      }

      if (indexDateTime.length === 0) {
        return;
      }

      for (const row of this.dataTable) {
        for (const dateColIndex of indexDateTime) {
          const dateValue = row[dateColIndex];
          if (dateValue) {
            row[dateColIndex] = this.Utc2Thai(dateValue);
          }
        }
      }
    },

    async GetTable() {
      this.loadingTable = true;
      let { page, itemsPerPage } = this.options;
      let request = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage,
        ID: this.id,
        Search: this.Search,
      };
      this.$call.GetTableDataIntegrationDetail(
        request,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.data.flag) {
              this.searchTotalTable = dataResponse.data.total;
              this.dataTable = dataResponse.data.data;
              this.normalizeDetailDateColumns();
              this.allowOptionWatch = true;
            } else {
              // โชว์เหตุผลจริงจาก backend (เช่น SSL/cert not trusted, login failed, invalid object)
              // ถ้าไม่มี message ค่อย fallback เป็นข้อความ generic
              this.showTopStatusWarning(
                dataResponse.data.message || this.$t("_Connection_failed"),
                4000
              );
            }
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    GetSearch() {
      this.isSearch = true;
      this.options.page = 1;
      this.GetTable();
    },
    AddNewRecord(value) {
      this.deleteAll = value;
      this.Adddialog = true;
    },
    async DeleteData(data) {
      let request = {
        ID: this.id,
        Data: data,
      };
      try {
        const result = await this.showDialog({
          title: this.$t("deleteRecords"),
          text: this.$t("_ConfirmDeleteItem"),
          icon: "delete",
          showCancelButton: true,
          confirmButtonText: this.$t("delete"),
          cancelButtonText: this.$t("cancel"),
        });

        if (result.isConfirmed) {
          this.dialog = true;
          this.$call.DeleteDataDataIntegrationDetail(
            request,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                this.showTopStatusBanner(this.$t("successfullyDeleted"));
                this.GetTable();
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              this.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        // Delete confirmation dismissed or flow aborted; no rethrow needed
        console.error("catch : DeleteData", error);
      }
    },
    async SaveAddDetail() {
      if (this.NewDataDetail.length != this.DataCol.length) {
        this.showTopStatusWarning(this.$t("warningFillAll"), 2500);
        return;
      }
      try {
        let request = {
          ID: this.id,
          NewData: this.NewDataDetail,
          deleteAll: this.deleteAll,
        };
        this.dialog = true;
        this.$call.AddDataDataIntegrationDetail(
          request,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.showTopStatusBanner(this.$t("successfullyCreated"));
              this.Adddialog = false;
              this.OldDataDetail = [];
              this.NewDataDetail = [];
              this.totalTable = this.totalTable + 1;
              this.GetTable();
            }else {
              this.showTopStatusWarning(dataResponse.message, 1500);
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // Add flow failed; dialog reset handled in error callback, no rethrow needed
        console.error("catch : UpdateData", error);
      }
    },
    async SaveEdit() {
      const validationResult = await this.$refs.editDetailForm?.validate?.();
      const hasIncompleteValues = this.hasIncompleteDetailValues(this.NewDataDetail, this.DataCol.length);
      if (!validationResult?.valid || hasIncompleteValues) {
        this.showTopStatusWarning(this.$t("warningFillAll"), 2500);
        return;
      }
      try {
        let request = {
          ID: this.id,
          OldData: this.OldDataDetail,
          NewData: this.NewDataDetail,
        };
        this.dialog = true;
        this.$call.UpdateDataDataIntegrationDetail(
          request,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.showTopStatusBanner(this.$t("successfullyUpdated"));
              this.closeEditDialog();
              this.totalTable = this.totalTable + 1;
              this.GetTable();
            } else {
              this.showTopStatusWarning(dataResponse.message || this.$t("warningFillAll"), 2500);
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // Update flow failed; dialog reset handled in error callback, no rethrow needed
        console.error("catch : UpdateData", error);
      }
    },
    AddData() {
      this.Adddialog = true;
    },
    EditData(data) {
      this.Editdialog = true;
      this.OldDataDetail = data;
      this.NewDataDetail = JSON.parse(JSON.stringify(data)); //NOSONAR
      this.$nextTick(() => {
        this.$refs.editDetailForm?.resetValidation();
      });
    },
    Utc2Thai(Input) {
      const utc = new Date(Input);
      const day = String(utc.getDate()).padStart(2, "0");
      const month = String(utc.getMonth() + 1).padStart(2, "0");
      const year = String(utc.getFullYear()).slice();
      return `${year}-${month}-${day}`;
    },
    validatecolumn() {
      if (this.DataCol.some((e) => e.newCol == "" || e.newCol == null)) {
        return "Column name is required!";
      }

      for (const item of this.DataCol) {
        let tmpCol = item.newCol;
        let count = this.DataCol.filter((e) => e.newCol == tmpCol).length;
        if (count > 1) {
          return "Column Duplicate!";
        }
      }

      return null;
    },

    async validateColumnNameAndType(ind) {
      if (this.validatingColumnIndex !== null) {
        return;
      }

      if(this.DataCol[ind].newCol == "" || this.DataCol[ind].newCol == null) {
        this.showTopStatusWarning(this.$t('_columnNameMissing'), 2500);
        this.focusColumnInput(ind);
        return;
      }
      let duplicateCheck = this.DataCol.filter(
        (e) => e.newCol == this.DataCol[ind].newCol
      );
      if (duplicateCheck.length > 1) {
        this.showTopStatusError(this.$t('_duplicateColumn'));
        this.focusColumnInput(ind);
        return;
      }

      this.validatingColumnIndex = ind;
      let temp = {
        id: this.id,
        ColumnChecklist: [this.DataCol[ind].newCol]
      };
      this.$call.ValidateExternalColumn(
        temp,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            const detectedDataType = dataResponse.data?.columns?.[0]?.dataType;
            this.DataCol[ind].typeId = detectedDataType;
            this.showTopStatusBanner(
              detectedDataType
                ? `${this.$t('columnValidated')}: ${detectedDataType}`
                : this.$t('_columnValidatedSuccess'),
              { timer: 2000 }
            );
          } else {
            this.showTopStatusError(dataResponse.data?.message || this.$t('_columnValidationFailed'));
          }
          this.validatingColumnIndex = null;
          this.focusColumnInput(ind);
        },
        async (errorResource) => {
          this.validatingColumnIndex = null;
          this.showTopStatusError(errorResource.message || this.$t('_validationServiceUnavailable'));
          this.focusColumnInput(ind);
          console.error(errorResource);
        }
      );
    },

    validatecDataType() {
      if (this.type == "E") {
        return null;
      }
      if (
        this.DataCol.some((e) => e.typeId == "" || e.typeId == null)
      ) {
        return "Please Fill All The Data Type!";
      }
      return null;
    },

    hasIncompleteDetailValues(values, expectedCount) {
      if (!Array.isArray(values) || values.length !== expectedCount) {
        return true;
      }

      return values.some((value) => value === null || value === undefined || (typeof value === "string" && value.trim() === ""));
    },

    closeEditDialog() {
      this.Editdialog = false;
      this.NewDataDetail = [];
      this.OldDataDetail = [];
      this.$nextTick(() => {
        this.$refs.editDetailForm?.resetValidation();
      });
    },

    async Save() {
      let spaceText = false;
      // Check if there are any columns with empty or null typeid
      this.DataCol.map((item,index) => {

        if (this.errorMessages.columns.length <= index) {
          this.errorMessages.columns.push({ error: false, message: '' });
        }

        const columnName = item.newCol ?? '';
        const splitText = columnName.split(' ');
        this.errorMessages.columns[index].error = false;
        this.errorMessages.columns[index].message = '';
        if (splitText.length > 1 && (splitText[0] === '' || splitText[splitText.length - 1] === '')) {
          this.errorMessages.columns[index].error = true;
          this.errorMessages.columns[index].message = this.$t('_columnNameSpaces');
          spaceText = true;
        }
      });

      if (spaceText) {
        this.showTopStatusWarning(this.$t('_columnNameSpaces'), 2500);
        return;
      }

      if (this.DataCol.some((e) => e.newCol == "" || e.newCol == null)) {
        this.showTopStatusWarning(this.$t("_pleaseFillAllFields"), 2500);
        return;
      }

      if (this.DataCol.some((e) => e.typeId == "" || e.typeId == null)) {
        this.showTopStatusWarning(this.$t("_validateColumnsBeforeSaving"), 2500);
        return;
      }

      const result = await this.showValidationSwal({
        icon: "warning",
        title: this.$t("_ConfirmDataUpdate"),
        text: this.$t("_confirmSaveChanges"),
        showCancelButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no") || "No",
        showCloseButton: false,
      });

      if (result.isConfirmed) {
        let flagColumn = this.validatecolumn();
        let flagDataType = this.validatecDataType();
        if (flagColumn == null && flagDataType == null) {
          this.dialog = true;
          let temp = {
            ID: this.id,
            DataJson: this.DataCol,
          };
          try {
            this.$call.UpdateDataIntegration(
              temp,
              async (dataResponse) => {
                if (dataResponse.status == 0) {
                  this.syncSchemaStateAfterSave();
                  this.showTopStatusBanner(dataResponse.message || this.$t("successfullySaved"));
                  this.dialog = false;
                  this.Get();
                  return;
                } else {
                  const errorContent = this.getSaveSchemaErrorContent(dataResponse.message);
                  this.showTopStatusError(errorContent.title);
                }
                this.dialog = false;
              },
              (errorResource) => {
                this.dialog = false;
                this.AddVector = false;
                console.error(errorResource);
              }
            );
          } catch (error) {
            this.LogTrace(error, "DeleteGroup");
          }
        } else if (flagColumn == null) {
          this.showTopStatusWarning(this.$t("_dataTypeMissing"), 2500);
          this.dialog = false;
        } else {
          this.showTopStatusWarning(
            flagColumn === 'Column Duplicate!'
              ? this.$t('_duplicateColumn')
              : this.$t('incompleteInformation'),
            2500
          );
          this.dialog = false;
        }
      }
    },
    async GetModelData() {
      this.dialog = true;
      await this.$call.GetDDLModelData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDModel = dataResponse.data;
            this.DDModelShow = this.listDDModel.filter(
              (e) => e.provider == "Azure"
            );
          } else {
            this.listDDModel = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    convertNumberToStringFormat(value) {
      const [intPart, decPart] = value.toString().split('.');
      const grouped = intPart.split('').reverse().join('').replace(/(\d{3})(?=\d)/g, "$1,").split('').reverse().join('');
      return decPart !== undefined ? `${grouped}.${decPart}` : grouped;
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.Entity = null;
        this.uploadedFiles = [];
        return;
      }
      this.DataRowUpload = [];
      const reader = new FileReader();
      const file = this.files[0];
      reader.onload = async (event) => {
        const buffer = event.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        // Get the first worksheet
        const worksheet = workbook.getWorksheet(1);
        if (!worksheet) {
          this.showTopStatusError(this.$t("_noWorksheetFound"));
          return;
        }

        // Extract data from the worksheet
        const jsonData = [];
        const headers = [];

        // Get headers from the first row
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          headers.push(cell.value);
        });
        jsonData.push(headers);

        // Get data from remaining rows
        let rowCount = 1; // Start from the second row (after headers)
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          const rowData = [];
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            rowData[colNumber - 1] = cell.value || "";
          });

          // Ensure rowData has the same length as headers
          while (rowData.length < headers.length) {
            rowData.push("");
          }

          if (this.isUploadedRowEmpty(rowData)) {
            return;
          }

          jsonData.push(rowData);
          rowCount++;
        });

        // Process the data
        this.DataRowUpload = jsonData.slice(1);
        let listindexnamefuzzy = [];
        this.DataCol.forEach((item) => {
          if (item.fuzzy || item.fuzzyBot) {
            let index = headers.indexOf(item.newCol);
            listindexnamefuzzy.push(index);
          }
        });

        this.totalTable += jsonData.length - 1;
        let chkValidateLimitFuzzy = this.ValidateLimitFuzzy(
          headers,
          listindexnamefuzzy
        );

        if (this.ValidateColumns(headers)) {
          this.showTopStatusError(this.$t("_duplicateColumn"));
        } else if (
          !this.arraysEqual(
            this.DataCol.map((e) => e.newCol),
            headers
          )
        ) {
          this.showTopStatusError(this.$t("_incorrectColumn"));
        } else if (chkValidateLimitFuzzy == null) {
          this.MapData(this.files);
          this.ConfirmProcess();
        } else {
          this.showTopStatusWarning(chkValidateLimitFuzzy, 2500);
          return;
        }
      };
      reader.readAsArrayBuffer(file); //NOSONAR
    },
    isUploadedRowEmpty(rowData) {
      return !rowData.some((value) => {
        if (value === null || value === undefined) {
          return false;
        }

        if (typeof value === 'string') {
          const normalized = value.trim();
          return normalized !== '' && normalized !== '-';
        }

        return true;
      });
    },
    ValidateLimitFuzzy(headers, listindexnamefuzzy) {
      for (const indexcol of listindexnamefuzzy) {
        for (let i = 0; i < this.DataRowUpload.length; i++) {
          let tmpdata = this.DataRowUpload[i][indexcol] ?? "";
          if (tmpdata.length > 800) {
            return this.$t("_dataExceedsFuzzyLimit", {
              column: headers[indexcol],
              row: i + 2,
            });
          }
        }
      }
      return null;
    },
    ValidateColumns(columns) {
      const uniqueColumns = [...new Set(columns)];
      return uniqueColumns.length !== columns.length; //มี Header ซ้ำ
    },
    arraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      let sortedArr1 = arr1.slice().sort();
      let sortedArr2 = arr2.slice().sort();

      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) return false;
      }

      return true;
    },
    MapData(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("uploaded_file", files[0]);
      this.uploadedFiles = files;
      this.Entity = formDataDoc;
    },
    async ConfirmProcess() {
      const result = await this.showDialog({
        icon: "warning",
        title: this.$t("ImportDataIntegration"),
        showCancelButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancel"),
      });

      if (result.isConfirmed) {
        this.SaveData();
      }
    },
    async SaveData() {
      this.dialog = true;
      let temp = {
        id: this.id,
        uploaded_file: this.Entity,
        deleteAll: this.deleteAll,
      };
      try {
        this.$call.AddDataIntegration_Data(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.showTopStatusBanner(dataResponse.message || this.$t('successfullySaved'));
              this.GetTable();
              this.AddDataIntegration = false;
            } else {
              this.showTopStatusError(dataResponse.message || this.$t('saveFailed'));
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    convertDateToString(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    convertToDate(dateString) {
      // ๝ยฝวันที่ เวลา ๝ละส่วนต่างๆ
      const parts = dateString.split(" ");
      const dateParts = parts[0].split("/");
      const timeParts = parts[1].split(":");

      // ๝ปลงปีจาฝพุทธศัฝราชเป็นคริสต์ศัฝราช
      let day = Number.parseInt(dateParts[0], 10);
      let month = Number.parseInt(dateParts[1], 10) - 1; // เดือนใน JavaScript เริ่มจาฝ 0
      let year = Number.parseInt(dateParts[2], 10); // ๝ปลงพุทธศัฝราชเป็นคริสต์ศัฝราช

      // สร้าง Date object
      return new Date(
        year,
        month,
        day,
        Number.parseInt(timeParts[0], 10),
        Number.parseInt(timeParts[1], 10),
        Number.parseInt(timeParts[2], 10)
      );
    },
    DeleteAction(index) {
      if (index > -1 && index < this.DataCol.length) {
        this.DataCol.splice(index, 1);
      }
    },
    AddColumn() {
      let temp = {
        name: "",
        fuzzy: false,
        fuzzyBot: false,
        personalInformation: false,
      };
      this.DataCol.push(temp);
    },
    transformValue(value) {
      if (typeof value === "string") {
        value = value.toLowerCase();
      }
      if (value === 1 || value === true || value === "true") {
        return "True";
      } else if (value === 0 || value === false || value === "false") {
        return "False";
      }
      return null; // ฝรณีที่ค่าไม่ตรงฝับสิ่งที่ต้องฝาร จัดฝารตามที่เห็นสมควร เช่น return null
    },
  },
  async mounted() {
    this.GetDate();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.importMode = this.$route.query.type;
      await this.Get();
    }

    
  },
};
</script>
<style scoped>
.card-detail-dataintegration {
  box-shadow: none !important;
}

.data-table-card {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: none !important;
  margin: 0px 10px 0px 10px;
}

.table-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 16px 24px !important;
  border-bottom: 1px solid #dee2e6;
}

.modern-table {
  background: white;
  animation: fadeIn 0.3s ease-in;
}

.table-header-cell {
  background: transparent !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 16px 12px !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2) !important;
  position: relative;
  text-align: center;
  text-transform: none !important;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.header-text {
  font-size: 0.875rem;
  letter-spacing: 0.5px;
  text-transform: none;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f3f4;
}

.table-row:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%) !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table-cell {
  padding: 12px !important;
  vertical-align: middle !important;
  border-bottom: 1px solid #f1f3f4 !important;
}

.cell-content {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.cell-text {
  font-size: 0.875rem;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

.action-cell {
  width: 120px;
  background: rgba(248, 249, 250, 0.5);
}

.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.datatable-action-btn) {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  min-height: 40px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}
:deep(.custom-expansion-title) .v-expansion-panel--active>.v-expansion-panel-header {
  min-height: 48px;
  background-color: transparent !important;
}
.edit-btn:hover {
  transform: scale(1.1);
}
.delete-btn{
  background: transparent !important;
}
.delete-btn:hover {
  transform: scale(1.1);
}

.table-footer {
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 8px 0;
}

/* Skeleton Loader Styling */
.v-skeleton-loader {
  background: transparent !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .table-header {
    padding: 12px 16px !important;
  }

  .table-header-cell {
    padding: 12px 8px !important;
  }

  .table-cell {
    padding: 8px !important;
  }

  .cell-text {
    max-width: 120px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}

/* Dark Mode Support */
.v-theme--dark .data-table-card {
  background: #1e1e1e !important;
}

.v-theme--dark .table-header {
  background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);
  border-bottom: 1px solid #404040;
}

.v-theme--dark .table-row {
  border-bottom: 1px solid #404040;
}

.v-theme--dark .table-row:hover {
  background: linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%) !important;
}

.v-theme--dark .table-footer {
  background: #2d2d2d;
  border-top: 1px solid #404040;
}

/* Animation for Loading */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Improved Scrollbar */
.modern-table ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.modern-table ::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.modern-table ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.modern-table ::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.custom-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 5px;
  margin-top: 20px;
}
.footer-center {
  margin: 0px 20px;
}
.footer-left{
  justify-content: end!important;
}
.footer-left,
.footer-center,
.footer-right {
  display: flex;
  align-items: center;
}

.footer-left span,
.footer-center span {
  font-size: 14px;
  color: #555;
}

.transparent-enabled {
  opacity: 0.7;
}
.transparent-enabled:hover {
  opacity: 1;
}
.transparent-disabled {
  opacity: 0.2;
  cursor: not-allowed;
}

.table-header-row {
  background: linear-gradient(135deg, rgba(56, 89, 208, 1) 0%, rgba(27, 55, 155, 1) 100%);
  color: white;
  font-weight: bold;
  text-transform: none!important;
  font-size: 14px;
}
.integration-name-sheet {
  background: #ffffff !important;
  padding: 16px !important;
  border-radius: 16px !important;
  margin: 0px;
  box-shadow: none !important;
}
.dialog-header-edit1{
  background: #ffffff !important;
  color: #000000!important;
}
.dialog-title1{
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.025em;
  color: #000000!important;
}
.dialog-subtitle1{
  color: #646464!important;
  font-size: 0.9375rem;
  margin: 0;
  line-height: 1.5;
  max-width: 420px;
}
.savebtn {
  background: linear-gradient(135deg, #C32E0E 0%, #F67760 100%);
  color: white !important;
}
.integration-name-label-simple {
  font-size: 0.75rem;
  font-weight: 500;
  color: #666;
  margin-bottom: 2px;
}

.integration-name-value-simple {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

/* Dark theme */
.v-theme--dark .integration-name-sheet {
  background: #2d2d2d !important;
}

.v-theme--dark .integration-name-label-simple {
  color: #bbb;
}

.v-theme--dark .integration-name-value-simple {
  color: #fff;
}
.custom-expansion-title {
  border-radius: 12px!important;
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 50px !important;
  text-transform: none!important;
  background: linear-gradient(135deg, #C32E0E, #F67760);
}

.custom-expansion-title::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.custom-expansion-title:hover::before {
  opacity: 1;
}

.expansion-title-content {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  position: relative;
  z-index: 1;
}

.expansion-header {
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none;
  letter-spacing: 0.8px;
}

.expansion-icon {
  transition: all 0.3s ease !important;
}
/* #region Custom Configuration Panels */
.configuration-container {
  padding: 8px;
}

.config-card-wrapper {
  margin-bottom: 16px;
}

.config-card {
  border-radius: 16px;
  border: 1px solid #DCDCDC;
  background: #FFF;
  box-shadow: none !important;
}

.config-card:hover {
  border-color: #C32E0E !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.1) !important;
}

.config-card-content {
  padding: 16px !important;
}

.config-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.config-title {
  font-size: 1rem;
  font-weight: 600;
  color: #000000;
  text-transform: none;
  letter-spacing: 0.5px;
}

.config-fields {
  margin-bottom: 12px;
}

.field-col {
  padding: 0 8px;
}

.field-col:first-child {
  padding-left: 0;
}

.field-col:last-child {
  padding-right: 0;
}

.config-field {
  margin-bottom: 8px;
}

.checkbox-container {
  display: flex;
  gap: 24px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f5f5f5;
}

.config-checkbox {
  flex: 0 0 auto;
}

.config-delete-btn {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.config-delete-btn:hover {
  opacity: 1;
}

.add-column-row {
  margin: 24px 0 16px 0;
}

.add-column-btn {
  height: 48px !important;
  border: 2px dashed #1976d2 !important;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  transition: all 0.2s ease;
}

.add-column-btn:hover {
  background: rgba(25, 118, 210, 0.05) !important;
  border-style: solid !important;
}

.save-btn {
  background-color: #348537 !important;
  color: white !important;
  border-radius: 8px;
  width: 120px;
  transition: all 0.2s ease;
}
.modern-panels {
  background: transparent;
  border-radius: 20px;
  padding: 0px;
}

.modern-panels :deep(.v-expansion-panel) {
  border-radius: 16px !important;
  margin-bottom: 16px;
  overflow: hidden;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}

.modern-panels :deep(.v-expansion-panel:not(:last-of-type)) {
  margin-bottom: 18px;
}

.modern-panels :deep(.v-expansion-panel-title) {
  min-height: auto;
  padding: 18px 24px;
  background:#FEE1DB;
  color: #171717 !important;
  transition: background-color 0.2s ease, padding 0.2s ease;
}
.modern-panels :deep(.expansion-header){
  color: #171717 !important;
}
.modern-panels :deep(.v-expansion-panel-title--active .expansion-header){
  color: #FFFFFF !important;
}
.modern-panels :deep(.v-expansion-panel-title--active) {
  background: linear-gradient(135deg, #C32E0E 0%, #F67760 100%);
}
.modern-panels :deep(.expansion-icon){
  color: #C32E0E;
}
.modern-panels :deep(.v-expansion-panel-title--active .expansion-icon){
  color: #FFFFFF !important;
}
.modern-panels :deep(.v-expansion-panel-title__overlay) {
  background-color: transparent !important;
}
.modern-input :deep(.v-field) {
  border-radius: 12px;
  transition: all 0.2s ease;
}
.modern-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}
.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}
/* Dropdown items per page */
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
.footerPerpage{
  border-radius: 10px !important;
}
:deep(.v-data-table-footer .v-select) {
  width: 80px !important;
}
.field-group {
  display: flex;
  flex-direction: column;
}
.field-label {
  font-weight: 500;
  margin-bottom: 4px;
  color: #333;
  font-size: 14px;
}
.required {
  color: red;
  margin-left: 2px;
}
.save-btn:hover {
  box-shadow: 0 4px 12px rgba(25, 210, 25, 0.3) !important;
} 
.addrecord{
  background: transparent;
    text-transform: none;
    width: 150px;
    margin: 20px 0px;
    border-radius: 15px;
    height: 45px;
    color: #646464;
}
/* Responsive Design */
@media (max-width: 768px) {
  .checkbox-container {
    flex-direction: column;
    gap: 8px;
  }

  .config-action-buttons {
    flex-direction: column;
  }

  .field-col {
    padding: 4px 0;
  }
}

/* Dark theme support */
.v-theme--dark .config-card {
  background: #2d2d2d !important;
  border-color: #404040 !important;
}

.v-theme--dark .config-card:hover {
  border-color: #64b5f6 !important;
}

.v-theme--dark .config-header {
  border-bottom-color: #404040;
}

.v-theme--dark .config-title {
  color: #64b5f6;
}

.v-theme--dark .checkbox-container {
  border-top-color: #404040;
}

.v-theme--dark .config-action-buttons {
  border-top-color: #404040;
}
/* #endregion */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 14px;
  align-self: center;
  border-radius: 1px;
}
/* Search Field Styling */
.search-field-container {
  padding: 8px;
}

.search-field {
  border-radius: 12px !important;
  transition: all 0.2s ease;
}

.search-field .v-field {
  border-radius: 12px !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
}

.search-field:focus-within .v-field {
  border-color: #1976d2 !important;
  background: rgba(25, 118, 210, 0.05) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1) !important;
}

.date-field .v-field {
  cursor: pointer;
}

/* Search Action Button */
.search-btn.compact {
  border-radius: 8px !important;
  height: 36px !important;
  font-weight: 500;
  text-transform: none;
  font-size: 0.875rem !important;
  padding: 0 16px !important;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.25) !important;
  transition: all 0.2s ease;
  min-width: 100px;
}

.search-btn.compact:hover {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.35) !important;
  transform: translateY(-1px);
}

.search-btn.compact .v-icon {
  font-size: 16px !important;
}

/* Alternative Minimal Style */
.search-btn.minimal {
  border-radius: 20px !important;
  height: 32px !important;
  font-weight: 500;
  text-transform: none;
  font-size: 0.8rem !important;
  padding: 0 12px !important;
  background: #e8f1fb !important;
  color: #176ec3 !important;
  border: 1px solid rgba(25, 118, 210, 0.3) !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
  min-width: 80px;
}

.search-btn.minimal:hover {
  background: rgba(25, 118, 210, 0.15) !important;
  border-color: #1976d2 !important;
  box-shadow: 0 2px 6px rgba(25, 118, 210, 0.2) !important;
}

/* Control Group */
.control-group {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap !important;
  gap: 12px;
  padding: 8px;
}

.process-type-select {
  min-width: 120px !important;
  border-radius: 12px !important;
}

.process-type-select .v-field {
  border-radius: 12px !important;
  background: rgba(156, 39, 176, 0.02) !important;
  border: 1px solid rgba(156, 39, 176, 0.2) !important;
}

.process-type-select:focus-within .v-field {
  border-color: #9c27b0 !important;
  background: rgba(156, 39, 176, 0.05) !important;
}

.info-icon {
  transition: all 0.2s ease;
}

.info-icon:hover {
  transform: scale(1.2);
  color: #1976d2 !important;
}

.upload-file-btn {
  border-radius: 12px !important;
  overflow: hidden;
}

/* Add Action Button */
.add-action-container {
  display: flex;
  align-items: center;
  padding: 8px 2px;
}

.add-btn {
  border-radius: 12px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  background: #ffffff !important;
  color: #3859D0 !important;
  border: 1px solid #3859D0 !important;
  transition: all 0.2s ease;
  width: 100%;
}

.add-btn:hover {
  background: #e1e6f8 !important;
  color: #3859D0 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .control-group {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }

  .process-type-select {
    min-width: auto !important;
  }

  .search-btn,
  .add-btn {
    width: 100%;
    height: 44px !important;
  }
}

/* Dark Theme Support */
.v-theme--dark .search-field .v-field {
  background: rgba(100, 181, 246, 0.05) !important;
  border-color: rgba(100, 181, 246, 0.3) !important;
}

.v-theme--dark .search-field:focus-within .v-field {
  border-color: #64b5f6 !important;
  background: rgba(100, 181, 246, 0.1) !important;
}

.v-theme--dark .process-type-select .v-field {
  background: rgba(186, 104, 200, 0.05) !important;
  border-color: rgba(186, 104, 200, 0.3) !important;
}

.v-theme--dark .process-type-select:focus-within .v-field {
  border-color: #ba68c8 !important;
  background: rgba(186, 104, 200, 0.1) !important;
}

/* Input Animation */
.search-field .v-field__input {
  transition: all 0.2s ease;
}

.search-field:focus-within .v-field__input {
  transform: translateY(-1px);
}

/* Enhanced Icons */
.search-field .v-field__prepend-inner {
  color: #1976d2 !important;
  opacity: 0.7;
}

.search-field:focus-within .v-field__prepend-inner {
  opacity: 1;
  transform: scale(1.1);
}

/* Button Group Styling */
.search-action-container,
.add-action-container {
  height: 100%;
}

/* Enhanced Hover Effects */
.v-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.v-btn:hover {
  filter: brightness(1.05);
}

/* Field Focus Ring */
.v-field--focused {
  outline: none !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2) !important;
}

/* Upload Proxy Button */
.upload-proxy-btn {
  border-radius: 12px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  background: #ffffff !important;
  color: #3859D0 !important;
  border: 1px solid #3859D0 !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
}

.upload-proxy-btn:hover {
  background: #e1e6f8 !important;
  box-shadow: 0 2px 8px rgba(56, 89, 208, 0.2) !important;
  color: #3859D0 !important;
}
/* Icon Animation */
.upload-proxy-btn .v-icon {
  transition: all 0.2s ease;
}

.upload-proxy-btn:hover .v-icon {
  transform: translateY(-1px) scale(1.05);
}

/* Loading State (Optional) */
.upload-proxy-btn.loading {
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}

.upload-proxy-btn.loading .v-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Hide the original DragDropFile */
.hidden-upload {
  display: none !important;
  visibility: hidden !important;
  position: absolute !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-proxy-btn {
    width: 100%;
    height: 44px !important;
    min-width: auto;
  }
}
/* Fuzzy Dropdown Styling */
.fuzzy-dropdown-container {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.fuzzy-select {
  height: 48px !important;
}

.fuzzy-select .v-field {
  border-radius: 8px !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
  transition: all 0.2s ease;
}

.fuzzy-select:focus-within .v-field {
  border-color: #1976d2 !important;
  background: rgba(25, 118, 210, 0.05) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1) !important;
}

.selection-content {
  display: flex;
  align-items: center;
}

.selection-text {
  font-size: 0.875rem;
  font-weight: 500;
}

.label-content {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 500;
  color: #666;
}

.fuzzy-list-item {
  padding: 8px 16px !important;
  transition: all 0.2s ease;
}

.fuzzy-list-item:hover {
  background: rgba(25, 118, 210, 0.05) !important;
}

.fuzzy-item-title {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  margin-bottom: 2px !important;
}

.fuzzy-item-subtitle {
  font-size: 0.75rem !important;
  opacity: 0.8 !important;
  line-height: 1.3 !important;
}

/* Compact Version */
.fuzzy-dropdown-container.compact {
  margin-top: 8px;
  padding-top: 8px;
}

.fuzzy-dropdown-container.compact .fuzzy-select {
  max-width: 250px;
}

.fuzzy-dropdown-container.compact .fuzzy-item-subtitle {
  display: none;
}

/* Dark Theme Support */
.v-theme--dark .fuzzy-select .v-field {
  background: rgba(100, 181, 246, 0.05) !important;
  border-color: rgba(100, 181, 246, 0.3) !important;
}

.v-theme--dark .fuzzy-select:focus-within .v-field {
  border-color: #64b5f6 !important;
  background: rgba(100, 181, 246, 0.1) !important;
}

.v-theme--dark .fuzzy-list-item:hover {
  background: rgba(100, 181, 246, 0.1) !important;
}

.v-theme--dark .label-content {
  color: #bbb;
}

.v-theme--dark .fuzzy-dropdown-container {
  border-top-color: #404040;
}

/* Enhanced Dropdown Animation */
.v-overlay__content {
  animation: dropdownSlide 0.2s ease-out;
}

@keyframes dropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom Scrollbar for Dropdown */
.v-list {
  max-height: 200px;
  overflow-y: auto;
}

.v-list::-webkit-scrollbar {
  width: 6px;
}

.v-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.v-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.v-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.modern-dialog-card {
  overflow: hidden !important;
  background: white !important;
  border: none !important;
}

.modern-dialog-header {
  background: linear-gradient(135deg, #39843c 0%, #39843c 100%) !important;
  color: white !important;
  padding: 24px !important;
  margin: 0 !important;
  position: relative;
  overflow: hidden;
}

.modern-dialog-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  pointer-events: none;
}

.modern-dialog-header.edit-header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%) !important;
}

.header-icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  backdrop-filter: blur(10px);
  border: 2px dashed rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.header-icon-wrapper.edit-icon {
  background: rgba(255, 255, 255, 0.15);
}

.header-text-wrapper {
  flex: 1;
}

.dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  margin: 0 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dialog-subtitle {
  font-size: 0.875rem !important;
  opacity: 0.9;
  margin: 4px 0 0 0 !important;
  font-weight: 400;
}

.modern-dialog-content {
  min-height: 400px;
}

.form-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
}

.form-grid {
  margin: 0 -12px;
}

.form-column {
  padding: 0 12px 16px 12px;
}

.field-container {
  position: relative;
}

.modern-field {
  margin-bottom: 8px;
}

.modern-field .v-field {
  border-radius: 12px !important;
  background: #fafafa !important;
  border: 2px solid #e3f2fd !important;
  transition: all 0.3s ease;
}

.modern-field:focus-within .v-field {
  border-color: #1976d2 !important;
  background: white !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
  transform: translateY(-1px);
}

.modern-field .v-field__prepend-inner {
  color: #1976d2 !important;
  opacity: 0.7;
  transition: all 0.2s ease;
}

.modern-field:focus-within .v-field__prepend-inner {
  opacity: 1;
  transform: scale(1.1);
}

.modern-date-picker {
  border-radius: 16px !important;
  overflow: hidden;
}

.modern-divider {
  border-color: #e0e0e0 !important;
  margin: 0 !important;
}

.modern-dialog-actions {
  padding: 20px 24px 24px 24px !important;
  background: white !important;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
}

/* Loading Animation for Save Button */
.dialog-action-btn.loading {
  opacity: 0.8;
  pointer-events: none;
}

.dialog-action-btn.loading .v-icon {
  animation: spin 1s linear infinite;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-dialog-header {
    padding: 20px 16px !important;
  }

  .header-icon-wrapper {
    width: 50px;
    height: 50px;
    margin-right: 16px;
  }

  .dialog-title {
    font-size: 1.25rem !important;
  }

  .modern-dialog-content {
    padding: 24px 16px !important;
  }

  .form-container {
    padding: 16px;
  }

  .form-grid {
    margin: 0 -8px;
  }

  .form-column {
    padding: 0 8px 12px 8px;
  }

  .actions-container {
    flex-direction: column;
  }

  .dialog-action-btn {
    width: 100% !important;
  }
}

/* Dark Theme Support */
.v-theme--dark .modern-dialog-card {
  background: #2d2d2d !important;
}

.v-theme--dark .modern-dialog-content {
  background: #1a1a1a !important;
}

.v-theme--dark .form-container {
  background: #2d2d2d;
  border-color: #404040;
}

.v-theme--dark .modern-field .v-field {
  background: #1a1a1a !important;
  border-color: rgba(100, 181, 246, 0.3) !important;
}

.v-theme--dark .modern-field:focus-within .v-field {
  border-color: #64b5f6 !important;
  background: #2d2d2d !important;
}

.v-theme--dark .modern-dialog-actions {
  background: #2d2d2d !important;
}

.v-theme--dark .cancel-btn {
  border-color: #C32E0E !important;
  color: #bbb !important;
}

.v-theme--dark .cancel-btn:hover {
  background: #C32E0E !important;
  border-color: #777 !important;
}

/* Animation for Dialog Entrance */
.v-dialog > .v-overlay__content {
  animation: dialogSlideIn 0.3s ease-out;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Field Validation Styling */
.v-field--error .v-field__outline {
  border-color: #f44336 !important;
}

.v-field--error .v-field__prepend-inner {
  color: #f44336 !important;
}

/* Enhanced Focus States */
.modern-field .v-field__input {
  transition: all 0.2s ease;
}

.modern-field:focus-within .v-field__input {
  color: #1976d2 !important;
}

/* Floating Label Animation */
.modern-field .v-field__label {
  transition: all 0.3s ease;
}

.modern-field:focus-within .v-field__label,
.modern-field .v-field__label--active {
  color: #1976d2 !important;
  font-weight: 600 !important;
}
.fuzzy-personal-container {
  margin-top: 12px;
  padding-top: 20px;
  border-top: 1px dashed #f0f0f0;
}

.fuzzy-dropdown-wrapper {
  padding-right: 8px;
  width: 100%;
}

.personal-info-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 8px;
}

.personal-info-container {
  background-color: #EDEDED;
  border: 1px solid #EDEDED;
  border-radius: 12px;
  padding: 4px 12px;
  width: 100%;
  transition: all 0.2s ease;
}

.personal-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.personal-info-label {
  display: flex;
  align-items: center;
  cursor: help;
}

.personal-info-switch {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.personal-info-switch :deep(.v-switch__track) {
  opacity: 0.4;
}

.validate-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 40px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  background: #f4f8fd;
  transition: all 0.2s ease;
  font-weight: 500;
  color: #1872cc;
}

.validate-button:hover {
  background: rgba(25, 118, 210, 0.1);
  border-color: #0d47a1;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .fuzzy-dropdown-wrapper {
    padding-right: 0;
    margin-bottom: 8px;
  }
  
  .personal-info-wrapper {
    padding-left: 0;
  }
}

/* Confirm Dialog Styles */
.confirm-dialog .v-overlay__content {
  animation: dialogBounceIn 0.3s ease-out;
}

@keyframes dialogBounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(-50px);
  }
  50% {
    opacity: 1;
    transform: scale(1.05) translateY(0);
  }
  100% {
    transform: scale(1) translateY(0);
  }
}

.confirm-card {
  overflow: hidden !important;
  border: none !important;
  border-radius: 16px !important;
}

.confirm-header {
  padding: 15px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.success-header {
  margin-top: 20px;
  height: 50px !important;
  border-radius: 16px !important;
  border: 1px solid #FFF !important;
  background: var(--success, linear-gradient(90deg, #1d863c 0%, #135928 100%)) !important;
  color: white !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  animation: slideDown 0.4s ease;
  padding: 0px;
}

.error-header {
  background: #d73b30 !important;
  color: white !important;
}
.delete-header {
  background: linear-gradient(180deg, #ffffff 0%, #fff1f0 100%);
  color: #dc3545 !important;
  text-transform: none !important;
}

.warning-header {
  background: #aa6500 !important;
  color: white !important;
}

.info-header {
  background: #1b79c4 !important;
  color: white !important;
}

.confirm-icon-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.confirm-title-text h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.confirm-content {
  padding: 20px 24px !important;
}

.confirm-message {
  font-size: 1rem;
  line-height: 1.5;
  color: #171717;
  margin: 0;
}

.confirm-actions {
  border-top: 1px solid #C9C9C9;
  padding: 15px !important;
  background: white;
}

.confirm-btn {
  min-width: 100px !important;
  height: 40px !important;
  border-radius: 12px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  transition: all 0.2s ease !important;
}

.cancel-btn {
  border: 1px solid #C32E0E !important;
  color: #C32E0E !important;
}

.cancel-btn:hover {
  background: #FDE4DF !important;
  border-color: #C32E0E !important;
  transform: translateY(-1px);
}
.confirm-btn-primary{
  min-width: 120px!important;
}
.confirm-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

/* Auto-close timer indicator */
.confirm-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: rgba(255, 255, 255, 0.7);
  animation: timerProgress linear;
}

/* Dark theme support */
.v-theme--dark .confirm-content {
  background: #1a1a1a;
}

.v-theme--dark .confirm-message {
  color: #bbb;
}

.v-theme--dark .confirm-actions {
  background: #2d2d2d;
}

:deep(.mdi-magnify.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default) {
  color: #C32E0E !important;
  opacity: 1 !important;
}
:deep(.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-icon--clickable.v-autocomplete__menu-icon){
  color: #C32E0E !important;
  opacity: 1 !important;
}
:deep(.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-select__menu-icon){
  color: #C32E0E !important;
  opacity: 1 !important;
}
:deep(.v-text-field .v-input__details){
  display: none !important;
}
/* Responsive design */
@media (max-width: 600px) {
  .confirm-header {
    padding: 20px 16px !important;
    flex-direction: column;
    text-align: center;
  }

  .confirm-icon-container {
    margin-right: 0;
    margin-bottom: 12px;
  }

  .confirm-content {
    padding: 16px !important;
  }

  .confirm-actions {
    padding: 12px 16px 16px 16px !important;
    flex-direction: column;
    gap: 8px;
  }

  .confirm-btn {
    width: 100% !important;
  }
}

:deep(.v-expansion-panel-text__wrapper) {
  padding: 8px 5px 8px 5px !important;
}
.record-detail-container {
  border-radius: 16px;
  border: 1px solid #DCDCDC;
  background: #FFF;
  margin: 10px !important;
  padding: 0px 10px 10px 10px !important;
}
</style>
